/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

    body,
    html,
    a {
        font-family: 'Nunito', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
    }

    a:hover {
        color: #000;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: ${props =>
        props?.primary_color ? props?.primary_color : `#0B0B0B`};
    }

    p {
        color: #121e38;
        font-size: 1.125rem;
    }

    h1 {
        font-weight: 600;
    }

    a {
        color: ${props =>
        props?.primary_color ? props?.primary_color : `#0d6efd`};
        text-decoration: underline; }
        a:hover {
          color: ${props =>
        props?.secondary_color ? props?.secondary_color : `#0a58ca`}; 
        }
    
    *:focus {
        outline: none;
    }

    .page-wrapper .page-body-wrapper .page-header .row .main-header h2, .page-wrapper .page-body-wrapper .page-header .row .main-header .h2{
        color: ${props =>
        props?.primary_color ? props?.primary_color : `#0B0B0B`};
    }

    .page-wrapper .page-body-wrapper .page-header .row .main-header h6, .page-wrapper .page-body-wrapper .page-header .row .main-header .h6{
        color: ${props =>
        props?.primary_color ? props?.primary_color : `#0B0B0B`};
    }

    .navbar-nav {
        align-items:center;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        padding: 1.25rem;
        text-align: left;
        padding-top: 2.5rem;
        padding-right: 2rem;
    }

    .anticon,
    .ant-notification-notice-icon-success {
        color: #1a4677;
    }
`;

export default GlobalStyles;
